<template>
<v-app>
      <router-view />
</v-app>
</template>

<script>
export default {
  name: 'App',
   watch: {
      '$route' (to) {
        document.title = to.meta.title || 'Backtrack'
      }
    },

  data: () => ({
    //
  }),
};
</script>
